import React, { Component } from 'react';
import { diagnosticLog } from '../utils/diagnosticLogger';
import { logReactBoundaryError } from '../utils/diagnosticUncaught';

export function logRenderBoundaryCaught(viewName, error, info) {
  try {
    const view = String(viewName || 'unknown');
    console.error(`[ViewErrorBoundary:${view}]`, error?.message);
    logReactBoundaryError(error, info);
    diagnosticLog('error', 'js:render', 'render_boundary_caught', {
      view,
      message: String(error?.message || error || 'React error').slice(0, 500),
    });
  } catch {
    /* never propagate from error handler */
  }
}

const CARD_STYLE = {
  margin: '16px auto',
  maxWidth: 420,
  padding: '16px 18px',
  borderRadius: 12,
  background: 'var(--bg-card, rgba(255,255,255,0.04))',
  border: '1px solid rgba(239,68,68,0.25)',
  color: 'var(--text-secondary, #bbb)',
  fontSize: 13,
  lineHeight: 1.5,
  textAlign: 'center',
};

const RETRY_BTN = {
  marginTop: 12,
  padding: '8px 18px',
  borderRadius: 8,
  background: '#C9A84C',
  color: '#1a1a2e',
  fontWeight: 700,
  fontSize: 13,
  border: 'none',
  cursor: 'pointer',
};

/**
 * Scoped render boundary — isolates one view/section so the rest of the app stays alive.
 */
export default class ViewErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this._retryKey = 0;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    logRenderBoundaryCaught(this.props.viewName, error, info);
  }

  handleRetry = () => {
    this._retryKey += 1;
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          data-view-boundary={this.props.viewName}
          data-testid={`view-boundary-error-${this.props.viewName}`}
          style={CARD_STYLE}
        >
          <div style={{ fontWeight: 700, color: 'var(--text-primary, #fff)', marginBottom: 6 }}>
            This section hit a problem
          </div>
          <div>Try again — the rest of Maestro is still running.</div>
          <button type="button" onClick={this.handleRetry} style={RETRY_BTN}>
            Retry
          </button>
        </div>
      );
    }

    return (
      <React.Fragment key={this._retryKey}>
        {this.props.children}
      </React.Fragment>
    );
  }
}
